import { render } from "./ExtranjeroSection.vue?vue&type=template&id=68bd02e8&scoped=true&ts=true"
import script from "./ExtranjeroSection.vue?vue&type=script&lang=ts"
export * from "./ExtranjeroSection.vue?vue&type=script&lang=ts"

import "./ExtranjeroSection.vue?vue&type=style&index=0&id=68bd02e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68bd02e8"]])

export default __exports__